import { SocketProvider } from '../context/socketContext';
import Login from '../pages/auth/login/Login';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const PrivateRoute = ({ children }) => {
	const location = useLocation();
	const { suburl } = useParams();
	const { userOnboardingMe } = useAuth();
	const { authToken, isOnboardingCompleted } = useSelector((state) => state.userInfo);
	const [isChecking, setIsChecking] = useState(true);
	const isLoginRoute = location.pathname === `/user/${suburl}`;

	useEffect(() => {
		const checkOnboarding = async () => {
			if (isLoginRoute) {
				setIsChecking(false);
				return;
			}

			if (!authToken) {
				setIsChecking(false);
				return;
			}

			if (isOnboardingCompleted) {
				setIsChecking(false);
				return;
			}

			try {
				await userOnboardingMe();
			} catch (err) {
				console.error('Onboarding check failed:', err);
			} finally {
				setIsChecking(false);
			}
		};

		checkOnboarding();
	}, [authToken, isOnboardingCompleted, isLoginRoute, userOnboardingMe]);

	if (isChecking) {
		return (
			<div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white z-3">
				<div className="text-lg">Loading...</div>
			</div>
		);
	}


	if (!authToken || isLoginRoute) {
		return <Login />;
	}

	if (!isOnboardingCompleted) {
		return null;
	}

	return <SocketProvider>{children}</SocketProvider>;
};

export default PrivateRoute;
